import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const groupsRequest = createAction(types.GROUPS_REQUEST);
export const groupsSuccess = createAction(types.GROUPS_SUCCESS);
export const groupsFailure = createAction(types.GROUPS_FAILURE);

export const groupRequest = createAction(types.GROUP_REQUEST);
export const groupSuccess = createAction(types.GROUP_SUCCESS);
export const groupFailure = createAction(types.GROUP_FAILURE);

export const createGroupRequest = createAction(types.CREATE_GROUP_REQUEST);
export const createGroupSuccess = createAction(types.CREATE_GROUP_SUCCESS);
export const createGroupFailure = createAction(types.CREATE_GROUP_FAILURE);

export const updateGroupRequest = createAction(types.UPDATE_GROUP_REQUEST);
export const updateGroupSuccess = createAction(types.UPDATE_GROUP_SUCCESS);
export const updateGroupFailure = createAction(types.UPDATE_GROUP_FAILURE);

export const deleteGroupRequest = createAction(types.DELETE_GROUP_REQUEST);
export const deleteGroupSuccess = createAction(types.DELETE_GROUP_SUCCESS);
export const deleteGroupFailure = createAction(types.DELETE_GROUP_FAILURE);

export const resetGroup = createAction(types.RESET_GROUP);

export default {
  resetGroup,
  groupsRequest,
  groupsSuccess,
  groupsFailure,
  groupRequest,
  groupSuccess,
  groupFailure,
  createGroupRequest,
  createGroupSuccess,
  createGroupFailure,
  updateGroupRequest,
  updateGroupSuccess,
  updateGroupFailure,
  deleteGroupRequest,
  deleteGroupSuccess,
  deleteGroupFailure,
};
